import styled from "styled-components";

export const UpiStepWrapper = styled.div({
    display: "flex",
    flexDirection: "column",
});

export const LottieContainer = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing.xxSmall,
    marginBottom: theme.spacing.large,
}));

export const ContentSection = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    padding: `0 ${theme.spacing.medium}`,
}));

export const UpiTextFieldSection = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xLarge,
    marginBottom: theme.spacing.xxLarge,
}));
